var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-step"},_vm._l((_vm.steps),function(step){return _c('div',{key:step.name,staticClass:"header-step__icon",class:{
      cur: step.index === _vm.curStep,
      pre: step.index < _vm.curStep,
      error: step.isError,
      warning: !step.isError && step.isWarning
    }},[(step.isLoading)?_c('svg-icon',{attrs:{"name":"step-loading","cls":'loading-icon'}}):_c('a',{on:{"click":function($event){return _vm.headerNext(step)}}},[_vm._v(_vm._s(step.index))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }